var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-bg",style:({
  'backgroundImage': 'url('+_vm.bgSrc+')'
}),on:{"click":function($event){return _vm.toDesc(_vm.link)}}},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")]),_c('a',{staticClass:"desc-a-link",on:{"click":function($event){return _vm.toDesc(_vm.link)}}},[_c('button',{staticClass:"btn-link btn-link-arrow"},[_vm._v("查看更多")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }